'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Link from 'next/link';
import { useState, useRef, useEffect, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@awesome.me/kit-94e593bf23/icons/sharp/regular';
import { faXmark, faDownload } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { faCheck } from '@awesome.me/kit-94e593bf23/icons/sharp/solid';
import { faHiveHeartLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import { faHeart } from '@awesome.me/kit-94e593bf23/icons/classic/solid';
import { toCurrency } from '@/app/_lib/services/ClientUtil';
import Price from '@/app/_components/Price';
import Tooltip from '@/app/_components/Tooltip';
const InfoTooltip = t0 => {
  const $ = _c(5);
  const {
    description
  } = t0;
  let t1;
  if ($[0] !== description) {
    t1 = <div className="max-w-64">{description}</div>;
    $[0] = description;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="ml-1.5 w-3.5 h-3.5 lowercase rounded-full bg-gray-30 text-white text-3xs font-mono font-medium inline-flex items-center justify-center hover:bg-primary transition-colors cursor-pointer">i</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <Tooltip content={t1} side="right">{t2}</Tooltip>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
const SwatchSetOnPage = t0 => {
  const $ = _c(26);
  const {
    swatchSet,
    selectSwatch,
    selectedSwatch,
    swatchSetErrors,
    displayErrors,
    swatchFavorites: t1
  } = t0;
  t1 === undefined ? [] : t1;
  const showAsTooltip = _temp;
  let handleSwatchSelect;
  let t2;
  let t3;
  let t4;
  if ($[0] !== displayErrors || $[1] !== selectSwatch || $[2] !== selectedSwatch || $[3] !== swatchSet || $[4] !== swatchSetErrors) {
    const namelessLongDesc = swatchSet.swatchLines?.filter(sl_0 => !sl_0.swatch_line_name && showAsTooltip(sl_0)) || [];
    let t5;
    if ($[9] !== selectSwatch || $[10] !== swatchSet.swatch_set_id || $[11] !== swatchSet.swatch_set_label) {
      t5 = async (event_0, swatch_0) => {
        event_0.preventDefault();
        event_0.stopPropagation();
        if (swatch_0.effective_price > 0) {
          swatch_0.display_name = `${swatch_0.swatch_name} <span class="pl-1 text-primary">+ ${toCurrency(swatch_0.effective_price)}</span>`;
        } else {
          swatch_0.display_name = swatch_0.swatch_name;
        }
        swatch_0.swatch_set_id = swatchSet.swatch_set_id;
        swatch_0.swatch_set_label = swatchSet.swatch_set_label;
        selectSwatch(swatch_0);
      };
      $[9] = selectSwatch;
      $[10] = swatchSet.swatch_set_id;
      $[11] = swatchSet.swatch_set_label;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    handleSwatchSelect = t5;
    t2 = "border-b border-gray-10";
    if ($[13] !== displayErrors || $[14] !== swatchSet.swatch_set_id || $[15] !== swatchSetErrors) {
      t3 = displayErrors && swatchSetErrors[swatchSet.swatch_set_id] && <div className="text-xs text-red transition-all duration-300">{swatchSetErrors[swatchSet.swatch_set_id]}</div>;
      $[13] = displayErrors;
      $[14] = swatchSet.swatch_set_id;
      $[15] = swatchSetErrors;
      $[16] = t3;
    } else {
      t3 = $[16];
    }
    t4 = selectedSwatch?.swatch_id ? <div className="flex flex-col items-start mb-2"><span className="text-xs text-light">Selected {swatchSet.swatch_set_label} <FontAwesomeIcon icon={faCheck} className="text-primary text-2xs ml-0.5" /></span><span className="text-md capitalize text-dark flex items-center flex-wrap"><span>{selectedSwatch.swatch_name}</span><span className="whitespace-nowrap">{selectedSwatch.swatch_code && <span className="text-light ml-1">({selectedSwatch.swatch_code})</span>}{selectedSwatch.effective_price > 0 && <span className="text-primary ml-1">+ <Price amount={selectedSwatch.effective_price} /></span>}</span>{namelessLongDesc.map(_temp2)}</span></div> : <span className="text-sm md:text-md text-light capitalize mb-2 flex items-center">{swatchSet.button_text}{namelessLongDesc.map(_temp3)}</span>;
    $[0] = displayErrors;
    $[1] = selectSwatch;
    $[2] = selectedSwatch;
    $[3] = swatchSet;
    $[4] = swatchSetErrors;
    $[5] = handleSwatchSelect;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    handleSwatchSelect = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  if ($[17] !== handleSwatchSelect || $[18] !== selectedSwatch?.swatch_id || $[19] !== swatchSet.swatchLines) {
    t5 = swatchSet.swatchLines && swatchSet.swatchLines.length > 0 && swatchSet.swatchLines.map(swatchLine => <div key={swatchLine.swatch_line_id} className="mb-4 tooltip-container">{swatchLine.swatch_line_name && <div className="text-xs text-dark capitalize mb-1 flex items-center"><span>{swatchLine.swatch_line_name}{swatchLine.price > 0 && <span className="text-primary">: + <Price amount={swatchLine.price} /></span>}</span>{showAsTooltip(swatchLine) && <InfoTooltip id={`swatch-line-desc-${swatchLine.swatch_line_id}`} description={swatchLine.swatch_line_description} />}</div>}{swatchLine.swatch_line_description && swatchLine.swatch_line_description.length > 0 && !showAsTooltip(swatchLine) && <p className="text-2xs text-light mb-1">{swatchLine.swatch_line_description}</p>}<div className="grid grid-cols-[repeat(auto-fill,55px)] gap-1">{swatchLine.swatches.map(swatch_1 => <Tooltip key={swatch_1.swatch_id} content={<>{swatch_1.swatch_name}{swatch_1.effective_price > 0 && <span className="text-primary pl-1">+ <Price amount={swatch_1.effective_price} /></span>}</>} side="bottom" mobileMode="disabled"><button onClick={e => handleSwatchSelect(e, swatch_1)} className="relative w-[55px] h-[55px]"><Image src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/swatch_photos/${swatch_1.swatch_photo}`} alt={swatch_1.swatch_name} fill={true} sizes="55px" className={`object-cover border-1 p-0.5 ${selectedSwatch?.swatch_id == swatch_1.swatch_id ? "border-primary rounded" : "border-white"}`} /></button></Tooltip>)}</div></div>);
    $[17] = handleSwatchSelect;
    $[18] = selectedSwatch?.swatch_id;
    $[19] = swatchSet.swatchLines;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5) {
    t6 = <div className={t2}>{t3}{t4}{t5}</div>;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
};
export default SwatchSetOnPage;
function _temp(sl) {
  return sl.description_tooltip == 1 && sl.swatch_line_description?.length > 0;
}
function _temp2(sl_1) {
  return <InfoTooltip key={sl_1.swatch_line_id} id={`swatch-line-desc-${sl_1.swatch_line_id}`} description={sl_1.swatch_line_description} />;
}
function _temp3(sl_2) {
  return <InfoTooltip key={sl_2.swatch_line_id} id={`swatch-line-desc-${sl_2.swatch_line_id}`} description={sl_2.swatch_line_description} />;
}